import { toast, Bounce, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
  transition: Bounce,
};

export const notifications = {
  success: (message: string, options?: Partial<ToastOptions>) => {
    toast.success(message, { ...defaultOptions, ...options });
  },

  error: (message: string, options?: Partial<ToastOptions>) => {
    toast.error(message, { ...defaultOptions, ...options });
  },

  info: (message: string, options?: Partial<ToastOptions>) => {
    toast.info(message, { ...defaultOptions, ...options });
  },

  warning: (message: string, options?: Partial<ToastOptions>) => {
    toast.warning(message, { ...defaultOptions, ...options });
  },

  loading: (message: string) => {
    return toast.loading(message, defaultOptions);
  },

  dismiss: (toastId?: string | number) => {
    toast.dismiss(toastId);
  },

  update: (toastId: string | number, render: any, options?: Partial<ToastOptions>) => {
    toast.update(toastId, {
      render,
      type: "success",
      isLoading: false,
      ...defaultOptions,
      ...options
    });
  }
};

// Legacy alert replacement - use this to replace window.alert() calls
export const showAlert = (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info') => {
  notifications[type](message);
};

export default notifications;